module.exports = __webpack_public_path__ + "static/media/19.7a6efe4b.jpeg";